import { useMutation } from '@tanstack/react-query';

import httpService from '@/lib/http.service';
import { MutationConfig } from '@/lib/react-query';

export interface CompletePaymentPayload {
  data: {
    orderReference: string;
    paymentReference: string;
  };
}

export const completePayment = ({ data: params }: CompletePaymentPayload) => {
  return httpService.post('/payments/complete', null, {
    params,
  });
};

type UseCompletePaymentOptions = {
  mutationConfig?: MutationConfig<typeof completePayment>;
};

export const useCompletePayment = ({ mutationConfig }: UseCompletePaymentOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (data, ...args) => {
      onSuccess?.(data, ...args);
    },
    ...restConfig,
    mutationFn: completePayment,
    retry: 0,
  });
};
